import "reflect-metadata"
import React from 'react';
import { CookiesProvider } from "react-cookie";
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import "./bootstrap/js/bootstrap"
import "./assets/js/app"
let persistor = persistStore(store);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>        
      </Provider>
    </CookiesProvider>
  </React.StrictMode>
);


